import { render, staticRenderFns } from "./SystemNoteWidget.vue?vue&type=template&id=63471e8e&scoped=true&"
import script from "./SystemNoteWidget.vue?vue&type=script&lang=ts&"
export * from "./SystemNoteWidget.vue?vue&type=script&lang=ts&"
import style0 from "./SystemNoteWidget.vue?vue&type=style&index=0&id=63471e8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63471e8e",
  null
  
)

export default component.exports